// extracted by mini-css-extract-plugin
export default {"root":"LesPhQ0v69bjtKkHgNPv","question":"hDeczKS4KrFBJ9w2c3Sc","question-text":"iQAyLbEflsr5Dd_PX7nR","questionText":"iQAyLbEflsr5Dd_PX7nR","menu":"pWE0rbtaQvGfF9a5NHc8"};